import(/* webpackMode: "eager" */ "/code/node_modules/.pnpm/next@15.5.9_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-dom@19._yf3e5grukrg4xcdbnzck25bsyy/node_modules/next/dist/client/image-component.js");
